module.exports = "/hwa/_next/static/images/wood-3fdb4a833837b02760394db06a310c29.png";